import { FC } from 'react'
import { IonText } from '@ionic/react'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { isAdmin } from '../../components/util/Auth'
import PageContainer from '../PageContainer'

interface OwnProps {
  id: string
  title?: string
  padding?: boolean
  actionButtonsEnd?: any
  actionButtonsStart?: any
}
interface AdminContainerProps extends OwnProps {}

const AdminContainer: FC<AdminContainerProps> = ({
  id,
  title,
  children,
  padding = true,
  actionButtonsEnd,
  actionButtonsStart,
}) => {
  const { user } = useAuthenticator((context) => [context.user])

  return (
    <PageContainer
      id={id}
      isPrivate={true}
      title={title}
      padding={padding}
      actionButtonsEnd={actionButtonsEnd}
      actionButtonsStart={actionButtonsStart}
    >
      {isAdmin(user) && <>{children}</>}
      {!isAdmin(user) && <IonText color='danger'>Access Denied (Admin role is required)</IonText>}
    </PageContainer>
  )
}

export default AdminContainer
